import React from "react";
import { StudentsUIProvider } from "./StudentsUIContext";
import { StudentsCard } from "./StudentsCard";

export function StudentsPage({ history, teacherId, term }) {
  return (
    <StudentsUIProvider>
      <StudentsCard 
        history={history}
        teacherId={teacherId}
        term={term}
      />
    </StudentsUIProvider>
 );
}